// import csb from '@cs/cs-bridge';
import getHrefParams from './get-href-params';
import { getRegionLocal } from '../utils';

export const appInfo = {
  isrtl: false,
  isPc: false,
  isIphonex: false,
  appId: '',
  appVersion: '',
  appName: '',
  // todo-why：暂时注释，考虑如何拿到
  // isIos: csb.isIos,
  // isApp: csb.isApp,
  isPartnerPos: false, // 是否是商家POS
  isPartner: false,
  isClientApp: false, // 是否是用户端
  clientAppVersion: '',
};

export const userInfo = {
  token: '',
  uuid: '',
};

export const deviceInfo = {
  os: '',
  osVersion: '',
};

// todo-why：暂时注释--端上应该用不到
// export const isPro = process.env.ENVIRONMENT === 'production';

// export const isSt = process.env.ENVIRONMENT === 'stage';

// export const isDev = process.env.NODE_ENV === 'development';

// // pike 业务标识
// export const PIKE_BIZ_ID = isPro ? 'pike_overseas_portal' : 'pike_overseas_portal';

// // pike 指定连接点
// // eslint-disable-next-line no-nested-ternary
// export const PIKE_DOMAIN = isPro ? 'https://pike.mykeeta.com' : isSt ? 'https://pikem0.inf.st.sankuai.com' : '';

// // 判断客户端是否是iphoneX及以上
// appInfo.isIphonex = (() => {
//   if (typeof window !== 'undefined' && window) {
//     return /iphone/gi.test(window.navigator.userAgent) && window.screen.height >= 812;
//   }
//   return false;
// })();

// // 判断客户端是否是pc
// function ispc(): void {
//   const userAgentInfo = window.navigator.userAgent;
//   const Agents = ['Android', 'iPhone', 'Windows Phone', 'iPad', 'iPod'];
//   for (let v = 0; v < Agents.length; v++) {
//     if (userAgentInfo.indexOf(Agents[v]) > -1) {
//       return;
//     }
//   }
//   appInfo.isPc = true;
// }
// ispc();

// // 判断客户端是否是商家端POS机器
// function isPartnerPos(): void {
//   const { clientType, from } = getHrefParams();
//   appInfo.isPartnerPos = clientType === 'b_android';
//   // 是否为商家端（不区分设备）
//   appInfo.isPartner = from?.includes('waimai_shop');
// }
// isPartnerPos();

// // 获取 C 端设备信息
// function getClientAppInfo(): void {
//   const { clientType, appVersion } = getHrefParams();
//   appInfo.isClientApp = ['c_android', 'c_ios'].includes(clientType);
//   appInfo.clientAppVersion = appVersion;
// }

// getClientAppInfo();

function isRtl(): void {
  const { locale } = getRegionLocal() || {};
  if (locale && String(locale).toLowerCase().startsWith('ar')) {
    appInfo.isrtl = true;
  } else {
    appInfo.isrtl = false;
  }
}
isRtl();

// async function getUserInfo() {
//   if (appInfo.isPc) {
//     return;
//   }
//   try {
//     const result = await knb.getUserInfo();
//     const { uuid, token } = result;
//     if (uuid) userInfo.uuid = uuid;
//     if (token) userInfo.token = token;
//   } catch {
//     // do nothing
//   }
// }

// async function getDeviceInfo() {
//   if (appInfo.isPc) {
//     return;
//   }
//   try {
//     const result = await knb.getDeviceInfo();
//     const { os, osVersion } = result;
//     if (os) deviceInfo.os = os;
//     if (osVersion) deviceInfo.osVersion = osVersion;
//   } catch {
//     // do nothing
//   }
// }

// async function getAppInfo() {
//   if (appInfo.isPc) {
//     appInfo.appName = 'pc';
//     return;
//   }
//   try {
//     const result = await knb.getAppInfo();
//     const { appid, package: packageName, version } = result;
//     if (appid) appInfo.appId = appid;
//     if (packageName) appInfo.appName = packageName;
//     if (version) appInfo.appVersion = version;
//   } catch {
//     // do nothing
//   }
// }

// getUserInfo();
// getDeviceInfo();
// getAppInfo();
